import {useAppSelector} from "../../app/hooks";
import {selectType} from "../deposit-form/depositFormSlice";
import FiatTransactionsTable from "./FiatTransactionsTable";
import CryptoTransactionsTable from "./CryptoTransactionsTable";

export default function TransactionsTable(){
    const type = useAppSelector(selectType);
    return type === 'fiat' ? <FiatTransactionsTable /> : <CryptoTransactionsTable />
}